<div class="job-highlight-item wtf">
  <div class="job-highlight-item__icon">
    <i class="fas {{ icon }}"></i>
  </div>
  <div class="job-highlight-item__content">
    <div class="job-highlight-item__label">{{ label }}</div>
    @if (valuesArray && valuesArray.length>1) {
    <div class="job-highlight-item__value">
      <ng-container *ngFor="let value of valuesArray; let last = last">
        {{ 'jobEmploymentTypes.' + value | transloco }}
        <ng-container *ngIf="!last">,</ng-container>
      </ng-container>
    </div>
    } @else {
    <div class="job-highlight-item__value">{{ value }}</div>
    }
  </div>
</div>
